const buildPersonalization = (customization) =>
  Object.assign({}, customization, { active: customization.free, value: "" });

export default buildPersonalization;
